import { useState } from 'react';
import { ru } from 'date-fns/locale';
import { Calendar } from '@/components/ui/calendar';
import { useDispatch, useSelector } from 'react-redux';
import { Separator } from '@/components/ui/separator';
import { userInfo } from '@/store/selectors/user';
import { setUser } from '@/store/slices/userSlice';
import { format } from 'date-fns';
import { useUpdateUser } from '../../profile/services/update';
import { t } from 'i18next';
import { EditChevron } from './EditChevron';

export const BirthdayInfo = () => {
  const user = useSelector(userInfo);
  const dispatch = useDispatch();
  const { updateUser } = useUpdateUser();
  const [birthdayOpen, setBirthdayOpen] = useState(false);

  const onSubmit = async (date?: Date) => {
    await updateUser({
      birthday: date as unknown as string,
    }).then(() => {
      dispatch(
        setUser({
          ...user,
          dob: date as unknown as string,
        })
      );
      setBirthdayOpen(false);
    });
  };

  return (
    <div className="flex flex-col">
      <div
        className="flex flex-row items-center justify-between"
        onClick={() => setBirthdayOpen(true)}
      >
        <p className="text-body-base-regular text-text-primary">{t('dob')}</p>
        <div className="flex flex-row items-center gap-2 pr-4">
          {user?.dob ? (
            <p className="text-body-base-regular text-text-tertiary">
              {format(user.dob, 'dd.MM.yyyy')}
            </p>
          ) : (
            <p className="text-body-base-regular text-brand-green">Указать</p>
          )}
          <EditChevron />
        </div>
      </div>
      {birthdayOpen && (
        <>
          <Separator className="mt-2" />
          <Calendar
            mode="single"
            selected={(user?.dob as unknown as Date) || new Date()}
            onSelect={onSubmit}
            locale={ru}
            toYear={new Date().getFullYear()}
          />
        </>
      )}
    </div>
  );
};
